module.exports = __webpack_public_path__ + "media/images/a_two-104657ca9ff67e6f873862ada9470dfd.png";